module.exports = __webpack_public_path__ + "media/assets/images/face-upload/facebook-4cfef5a2c8c632099eb95e5abe3cb164.png";